type GenerateKeyForFieldArgs = {
	fieldId: string;
	isRequiredOverride: boolean;
};
export const generateKeyForField = ({
	fieldId,
	isRequiredOverride,
}: GenerateKeyForFieldArgs): string =>
	`${fieldId}-field-${isRequiredOverride ? '' : 'non-'}required`;
